<script setup lang="ts"></script>

<template>
  <div class="tickets">
    <!-- qic-connect-ignore-next-line -->
    <img src="@/shared/assets/images/ticket.svg" />
    <span>{{ $t('ramadan.select_plan_label.outbound') }}</span>
  </div>
</template>

<style scoped lang="scss">
  @use './TicketChancesBlock';
</style>
